import { FormatDate, GetDateFromString } from "../../../../shared/scripts/date-functions";

export class Announcement {
    Id: number;
    Title: string;
    Description: string;
    AnnouncementDate: string;
    AnnouncementDateFormatted: string;
    Link: string;
    ImageFile: string;
    SortOrder: number;

    Initialize(): void {
        const d = GetDateFromString(this.AnnouncementDate, 'hyphens-year-month-day');
        this.AnnouncementDateFormatted = FormatDate(d, "mo-day-year");
    }
}